import React from 'react';
import { Box, Button, Menu, MenuButton, MenuList, MenuItem, Avatar, Badge, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCurrentUserHighestRole } from '../../auth/keycloak';

export default function UserAvatarMenu({
  role,
  userData,
  avatarUrl,
  onLogout,
}: {
  role: string;
  userData?: { id: number; fullName?: string; email?: string } | null;
  avatarUrl?: string;
  onLogout: () => void;
}): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Menu placement="bottom-end">
      <MenuButton
        as={Button}
        variant="ghost"
        p={0}
        borderRadius="full"
        minW="auto"
        h="auto"
        flexShrink={0}
      >
        <Box position="relative" display="inline-block">
          <Avatar
            size="sm"
            src={avatarUrl}
            name={userData?.fullName || userData?.email || t('common.user')}
            flexShrink={0}
          />
          <Badge
            position="absolute"
            bottom="-6px"
            right="-8px"
            fontSize="7px"
            px={1}
            py={0.5}
            borderRadius="sm"
            colorScheme={role === 'ADMIN' ? 'red' : role === 'TEACHER' ? 'blue' : 'green'}
            textTransform="none"
            fontWeight="semibold"
            whiteSpace="nowrap"
            lineHeight="1.2"
          >
            {role === 'ADMIN' ? t('role.admin') : role === 'TEACHER' ? t('role.teacher') : t('role.student')}
          </Badge>
        </Box>
      </MenuButton>
      <MenuList>
        <Box px={3} py={2} borderBottomWidth="1px">
          <Text fontSize="sm" fontWeight="medium">
            {userData?.fullName || t('common.user')}
          </Text>
          <Text fontSize="xs" color="gray.500">
            {userData?.email || ''}
          </Text>
        </Box>
        {userData?.id && (
          <MenuItem onClick={() => navigate(`/users/${userData.id}`)}>{t('nav.viewProfile')}</MenuItem>
        )}
        <MenuItem onClick={() => navigate('/')}>{t('nav.home')}</MenuItem>
        <MenuItem onClick={() => navigate('/profile')}>{t('nav.editProfile')}</MenuItem>
        {getCurrentUserHighestRole() === 'ADMIN' && (
          <MenuItem onClick={() => navigate('/admin')}>{t('nav.admin')}</MenuItem>
        )}
        <MenuItem onClick={onLogout}>{t('nav.logout')}</MenuItem>
      </MenuList>
    </Menu>
  );
}
